export default __webpack_public_path__ + "03e4300d3fda5a9d6dd23f8e1b700d4e.png";